module.exports = __webpack_public_path__ + "img/40_38_022_970.8a5de98d.jpg";